const STORAGE_KEY = 'gsc-dismissed-notifications';

function getDismissedSet(): Set<string> {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return new Set();
        return new Set(JSON.parse(raw));
    } catch {
        return new Set();
    }
}

function saveDismissedSet(set: Set<string>): void {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify([...set]));
    } catch {
        // ignore write errors
    }
}

export function isDismissed(notificationId: string): boolean {
    return getDismissedSet().has(notificationId);
}

export function dismissNotification(notificationId: string): void {
    const set = getDismissedSet();
    set.add(notificationId);
    saveDismissedSet(set);
}

export function clearDismissals(): void {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch {
        // ignore errors
    }
}
